<template>
	<home-tile
		color="cerulean"
		button-title="Make A One-time gift"
		:loading="isLoading"
		@click="handleDonateNow"
	>
		<h3>Give a little extra!</h3>
		<span class="tile-text-small" v-if="cause.type === 'group'">
			Did you know {{ fact }}? So every dollar helps.
		</span>
		<span class="tile-text-small" v-else>
			{{ fact }}
		</span>
		<div class="donate">
			<segment-toggle
				:value="gift"
				:options="options"
				@on-change="setGift"
				name="donate"
				labelPrefix="$"
			/>
		</div>
		<label
			v-if="gift === 'custom'"
			:style="{ marginTop: '15px', maxWidth: '250px', margin: 'auto' }"
		>
			<p>Look at you making an impact! Enter your gift below:</p>
			<ui-input
				v-model="custom_gift"
				placeholder="$100"
				native-type="number"
				type="blue"
			/>
		</label>
	</home-tile>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import HomeTile from './HomeTile'
import UiInput from '../../ui/Input'
import SegmentToggle from '../../ui/SegmentToggle'

export default {
	name: 'donate-extra-tile',
	components: { HomeTile, UiInput, SegmentToggle },
	data() {
		return {
			gift: 10,
			custom_gift: null,
			isLoading: false
		}
	},
	computed: {
		...mapState({
			home: ({ home }) => home.item
		}),
		...mapGetters(['user', 'cause']),
		options() {
			return this.cause.type !== 'group'
				? [1, 5, 10, 25, 'custom']
				: [10, 15, 25, 50, 'custom']
		},
		fact() {
			if (this.cause.type === 'group') {
				return this.cause.fact.replace(/\.$/, '')
			}
			return this.cause.fact
		}
	},
	methods: {
		...mapActions(['donateNow', 'reprocessRoundup']),
		setGift(val) {
			this.gift = val
		},
		handleDonateNow() {
			this.isLoading = true
			let amount = this.gift
			if (this.gift === 'custom') {
				amount = this.custom_gift
			}

			if (this.cause.type === 'group' && amount < 10) {
				this.$swal(
					'Error',
					'In order to effectively support multiple organizations, we require a minimum donation of at least $10.'
				)
				this.isLoading = false
				return
			}

			const acceptibleErrors = [
				'Your card was declined.',
				'Your card has insufficient funds.',
				'An error occurred with our connection to Stripe.'
			]

			this.donateNow(amount)
				.then(() => {
					this.isLoading = false
					this.$swal(
						'Thanks',
						'You successfully donated $' +
							amount +
							'! Check your email for a confirmation.'
					)
				})
				.catch(({ message, data }) => {
					this.isLoading = false
					let action = 'Retry Donation'
					if (!acceptibleErrors.includes(message)) {
						action = 'Add New Card'
					}

					this.$swal({
						title: 'Uh Oh!',
						text: message,
						showCancelButton: true,
						cancelButtonText: action,
						allowOutsideClick: false,
						allowEscapeKey: false
					}).then((result) => {
						if (result.value) {
							return
						}
						if (acceptibleErrors.includes(message)) {
							this.isLoading = true
							this.reprocessRoundup(data.payoutId).catch(
								(error) => {
									this.isLoading = false
									this.handleErrors(error.message)
								}
							)
						} else {
							this.navigate({ name: 'card' }, 'forward')
						}
					})
				})
		},
		handleErrors() {
			this.$swal({
				title: 'Uh Oh!',
				text: 'Your donation failed twice with this card. We suggest adding a new one.',
				showCancelButton: true,
				cancelButtonText: 'Add New Card',
				allowOutsideClick: false,
				allowEscapeKey: false
			}).then((result) => {
				if (result.value) {
					return
				}
				this.navigate({ name: 'card' }, 'forward')
			})
		}
	},
	mounted() {
		this.gift = this.cause.type !== 'group' ? 1 : 15
	}
}
</script>

<style lang="scss">
.donate {
	.segmented-control {
		background: $navy;
		display: flex;
		width: 100%;
		margin-top: 20px;
		margin-bottom: 0px;
		padding: 0;
		border-radius: 25px;
		.segmented-control__item {
			flex-grow: 1;
			flex-basis: 0;
			margin: 0;
			padding: 0;
			list-style-type: none;
		}
		.segmented-control__input {
			position: absolute;
			visibility: hidden;
		}

		.segmented-control__input:checked + .segmented-control__label {
			background: $white;
			color: $navy-highlight;
		}
		.segmented-control__label {
			display: block;
			padding: 15px 10px;
			text-align: center;
			cursor: pointer;
			border-radius: 25px;
			font-weight: bold;
			&:hover {
				background: $navy-highlight;
				color: $white;
			}
		}
	}
}
</style>
